import {Moment} from "moment";
import {Vnode} from "mithril";
import m from "mithril";
import DatePicker from "./DatePicker";
import {DateTimeInputBoxOptions} from "./DateTimeInputBox";

/**
 * One input box of datepicker
 *
 * |----------|
 * |    /\    |  <-- addCallback
 * |          |
 * |    ##    |  <-- Current value - dateFormatCallback
 * |          |
 * |    \/    |  <-- subCallback
 * |----------|
 *
 */
export default class DateTimeInputBoxNotNumeric {

    constructor(
        private readonly datepicker: DatePicker,
        private readonly dateFormatCallback: (date: Moment|null) => string,
        private readonly modifyCallback: (date: Moment|null, n: number) => Moment,
        private readonly options: DateTimeInputBoxOptions = {}
    ) { }


    public set date(date: Moment|null) {
        if (date !== null) {
            if (this.options.minDate && this.options.minDate.diff(date) < 0) {
                // date is before minDate
                this.datepicker.date = this.options.minDate;
            } else if (this.options.maxDate && this.options.maxDate.diff(date) > 0) {
                // date is after maxDate
                this.datepicker.date = this.options.maxDate;
            } else {
                // date is in range
                this.datepicker.date = date;
            }
        } else {
            // date is not set yet
            this.datepicker.date = null;
        }
    }

    public get date() {
        return this.datepicker.date;
    }


    //------------------------._.-^
    // VIEW
    //
    public view(): Vnode {

        return m('.date-box.not-numeric', {}, [
            m('.box-top',{}, this.viewArrow("add")),
            m('.box-middle',{}, this.viewInput()),
            m('.box-bottom',{}, this.viewArrow("sub")),
        ])

    }

    private viewArrow(direction: "add"|"sub"): Vnode {
        return m('.control.'+direction, {
            onclick: () =>  {
                this.date = this.modifyCallback(this.date, direction === "add" ? 1 : -1);
            }
        });
    }

    private viewInput(): Vnode {
        // Set required attributes
        const value = this.date === null ? '' : this.dateFormatCallback(this.date);

        return m('span', {}, value);
    }
}